module.exports = __webpack_public_path__ + "img/error.21a44bdd.png";